import axios from "axios";

class ViaCepService {
  ViaCepAPI = axios.create({
    baseURL: "https://viacep.com.br/ws/",
  });
  
  async getCep(cep: string): Promise<any> {
    try {
      return await this.ViaCepAPI.get(`${cep}/json`).then((response) => {
        return response.data;
      });
    } catch (error) {
      console.error(error);
    }
  }
}

export default new ViaCepService();